import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GrocyQuantityUnitBasics } from '../../../core/entities/grocy/quantity-units/quantity-unit-basics.entity';
import { StaticDataService } from '../../../core/services/static-data.service';
import { fieldIsRequired } from '../../utils/forms.utils';

@Component({
  selector: 'app-grocy-quantity-unit-input',
  templateUrl: './grocy-quantity-unit-input.component.html',
  styleUrl: './grocy-quantity-unit-input.component.scss',
})
export class GrocyQuantityUnitInputComponent implements OnInit {
  @Input({ required: true }) control!: FormControl<GrocyQuantityUnitBasics | null>;
  @Input() label: string = 'Quantity Unit';

  isRequired = fieldIsRequired;
  options: GrocyQuantityUnitBasics[] = [];

  constructor(private staticDataService: StaticDataService) {}

  ngOnInit(): void {
    this.staticDataService.getGrocyContextData().subscribe(contextData => {
      this.options = contextData.quantityUnits;
    });
  }
}
